<div class="width-1100">

    <mat-card>
        <mat-toolbar class="toolbar-top">

            <div class='title'>
                <mat-icon>settings</mat-icon>
                <div>Query</div>
            </div>

            <div flex justify-content='flex-end' fxLayoutAlign="end">
                <a mat-button mat-raised-button  (click)="runQuery()" style='width:60px;'>
                    <mat-icon class='icon-done'>check_circle_outline</mat-icon>
                </a>
            </div>

        </mat-toolbar>
    </mat-card>

    <mat-card class='content'>

        <div *ngFor="let result of display_results" style='margin: 0 10px 0 10px;'>
            <div><b>{{ result.name }}</b></div>
            <div>ID: {{ result.id }}</div>
            <div>Antes: {{ result.old_category_name }}</div>
            <div>Depois: {{ result.new_category_name }}</div> 
            <div>Sócio: {{ result.socio }}</div>
            <hr>
        </div>

    </mat-card>

</div>